import React, { useEffect, useState } from 'react';
import { contentAPI } from '../utils/api';

/**
 * "As Featured In" press logo strip.
 * Renders below the hero. Hides itself if there are no items, so admin can
 * empty the collection without leaving an empty band on the page.
 */
const PressStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    contentAPI.getPress().then((d) => setItems(Array.isArray(d) ? d : []));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section
      className="py-12 md:py-16 bg-[#0f0f0e] border-t border-b border-white/5"
      data-testid="press-strip"
    >
      <div className="max-w-6xl mx-auto px-6">
        <p
          className="text-center text-[10px] md:text-xs tracking-[0.45em] uppercase text-[#C9A86C] mb-8"
          style={{ fontFamily: 'var(--font-serif)' }}
        >
          As Featured In
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-10 md:gap-x-16 gap-y-6">
          {items.map((p, idx) => {
            const inner = p.logo_url ? (
              <img
                src={p.logo_url}
                alt={p.name}
                className="h-7 md:h-9 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            ) : (
              <span
                className="text-white/55 hover:text-white text-xl md:text-2xl tracking-wider transition-colors duration-300"
                style={{ fontFamily: 'var(--font-serif)' }}
              >
                {p.name}
              </span>
            );
            return p.link_url ? (
              <a
                key={p._id || p.name || idx}
                href={p.link_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`press-logo-${idx}`}
              >
                {inner}
              </a>
            ) : (
              <span key={p._id || p.name || idx} data-testid={`press-logo-${idx}`}>
                {inner}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PressStrip;
